export function FailRender() {
  return (
    <div>
      <div>未输入数据</div>
      <div>搭建器使用流程：提交 -> 保存草稿 -> 生效</div>
    </div>
  )
}
